import React from "react";
import { BsPersonFill } from "react-icons/bs";
import PageHeaderContent from "../../components/pageHeaderContent/";
import { Animate } from "react-simple-animate";
import "./style.scss";

import youtube from "../../images/Other/youtube.png"
import linkedIn from "../../images/Other/linkedin.png"
import github from "../../images/Other/github.png"

const personalDetails = [
  {
    label: "Name: ",
    value: "Rasintha Lahiru",
  },
  {
    label: "Nationality: ",
    value: "Sri Lankan",
  },
  {
    label: "Languages: ",
    value: "English (fluent) & Sinhala",
  },
  {
    label: "Current City: ",
    value: "Ipswich",
  },
  {
    label: "Hobbies and Interests: ",
    value: "Fitness, Travel, Gaming ",
  },
  {
    label: "Email: ",
    value: "lahirurasi@gmail.com",
  },
  {
    label: "Contact No: ",
    value: "+44 7341 367867",
  },
];

const socielMediaDetails = [
  {
    label: <a href="https://www.linkedin.com/in/rasintha-lahiru/" target="_blank" rel="noopener noreferrer"><img src={linkedIn} alt="LinkedIn" width={60}/></a> ,
  },
  {
    label: <a href="https://github.com/TechPodx" target="_blank" rel="noopener noreferrer"><img src={github} alt="github" width={60} /></a> ,
  },
  {
    label: <a href="https://www.youtube.com/@TheLearningAutomator" target="_blank" rel="noopener noreferrer"><img src={youtube} alt="youtube" width={60}/></a> ,
  },
];

const jobSummery =
  "I’m a tech-driven problem solver with a strong foundation in data analytics, data science, machine learning, and modern web technologies. With hands-on experience applying analytical and predictive techniques to uncover data-driven insights and building responsive web applications with React, I bring a versatile and practical skill set. I have advanced expertise in Excel and Power BI for data analysis and visualization, along with strong proficiency in SQL and Python for data manipulation, automation, and model development. Over the years, I’ve collaborated with cross-functional teams and supported freelance clients across finance, healthcare, logistics, and technology, delivering solutions ranging from streamlined automation workflows to full-scale digital and analytical platforms. I’m passionate about leveraging technology to solve complex problems, optimize performance, and drive innovation. A firm believer in continuous learning, I stay current with emerging trends in AI, automation, and GenAI. My ongoing studies in Data Science and Software Engineering further strengthen my ability to design intelligent, data-centric solutions that deliver real-world value.";

const About = () => {
  return (
    <section id="about" className="about">
      <PageHeaderContent
        headerText="About Me"
        icon={<BsPersonFill size={40} />}
      />
      <div className="about_content">
        <div className="about_content_wrapper">
          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(-900px)",
            }}
            end={{ transform: "translatex(0px)" }}
          >
            <h3>Freelance Developer</h3>
            <p>{jobSummery}</p>
          </Animate>

          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(500px)",
            }}
            end={{ transform: "translatex(0px)" }}
          >
            <h3 className="personalInfo">Personal Information</h3>
            <ul>
              {personalDetails.map((item, i) => (
                <li key={i}>
                  <span className="title">{item.label}</span>
                  <span className="value">{item.value}</span>
                </li>
              ))}
            </ul>
            
            <div className="connect">
              <h3 className="personalInfo">Find Me Online</h3>
              <ul className="connect_me">
                {socielMediaDetails.map((item, i) => (
                  <li key={i}>
                    <span className="title">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
            
          </Animate>
        </div>
        <div className="about_content_wrapper_services">
          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(550px)",
            }}
            end={{ transform: "translatex(0px)" }}
          >
            <div className="about_content_wrapper_services_box"></div>
          </Animate>
        </div>
      </div>
    </section>
  );
};

export default About;
